import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const HERO = "https://images.unsplash.com/photo-1682745230951-8a5aa9a474a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBoYW5kYmFnJTIwdG90ZSUyMGxlYXRoZXIlMjBzdHVkaW8lMjBwcm9kdWN0fGVufDB8fHx8MTc5MDAwMjg4NHww&ixlib=rb-4.1.0&q=85";
const LOOK1 = "https://images.unsplash.com/photo-1683921470299-b8f0f3331657?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBmYXNoaW9uJTIwaGFuZGJhZyUyMG1vZGVsJTIwcGhvdG9zaG9vdCUyMHN0dWRpb3xlbnwwfHx8fDE3OTAwMDI4ODR8MA&ixlib=rb-4.1.0&q=85";
const DARK = "https://images.pexels.com/photos/10296778/pexels-photo-10296778.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const CATS = [
  { name: "Handbags", img: "https://images.pexels.com/photos/27100523/pexels-photo-27100523.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Tote Bags", img: "https://images.unsplash.com/photo-1614179689702-355944cd0918?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBoYW5kYmFnJTIwdG90ZSUyMGxlYXRoZXIlMjBzdHVkaW8lMjBwcm9kdWN0fGVufDB8fHx8MTc5MDAwMjg4NHww&ixlib=rb-4.1.0&q=85" },
  { name: "Crossbody Bags", img: "https://images.pexels.com/photos/27127406/pexels-photo-27127406.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Clutches", img: "https://images.unsplash.com/photo-1590739225287-bd31519780c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmYXNoaW9uJTIwaGFuZGJhZyUyMG1vZGVsJTIwcGhvdG9zaG9vdCUyMHN0dWRpb3xlbnwwfHx8fDE3OTAwMDI4ODR8MA&ixlib=rb-4.1.0&q=85" },
];

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [newArr, setNewArr] = useState([]);
  const [best, setBest] = useState([]);
  const [sale, setSale] = useState(null);

  useEffect(() => {
    api.get("/products?featured=true&limit=6").then((r) => setFeatured(r.data));
    api.get("/products?new_arrival=true&limit=4").then((r) => setNewArr(r.data));
    api.get("/products?bestseller=true&limit=4").then((r) => setBest(r.data));
    api.get("/sale/active").then((r) => { if (r.data.active) setSale(r.data); }).catch(() => {});
  }, []);

  return (
    <div className="fade-up">
      {sale && (
        <div className="bg-[#C5A059] text-[#121212] text-center py-3 text-xs uppercase tracking-[0.25em] font-medium" data-testid="sale-banner">
          {sale.name} · {sale.discount_percent}% off storewide{sale.end_at ? ` · ends ${new Date(sale.end_at).toLocaleDateString("en-IN", { day: "numeric", month: "long" })}` : ""}
        </div>
      )}
      {/* HERO */}
      <section className="relative h-[85vh] min-h-[560px] w-full overflow-hidden">
        <img src={HERO} alt="LEE BAG" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#121212]/60 via-transparent to-transparent" />
        <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col justify-center text-[#FBF9F5]">
          <p className="eyebrow text-[#E6C687]">The Signature Collection 2026</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-4 max-w-2xl">Handcrafted for the woman who wears her legacy.</h1>
          <p className="mt-6 text-sm md:text-base max-w-md text-[#EFEAE1]">Full-grain Indian leather. Every piece signed, numbered, and authenticated with a unique LEE BAG QR certificate.</p>
          <div className="mt-10 flex gap-4">
            <Link to="/shop" className="btn-lux-gold" data-testid="hero-cta-shop">Discover the Collection</Link>
            <Link to="/story" className="btn-lux-outline text-[#FBF9F5] border-[#FBF9F5]" data-testid="hero-cta-story">Our Story</Link>
          </div>
        </div>
      </section>

      {/* Marquee */}
      <div className="bg-[#121212] text-[#FBF9F5] py-6 overflow-hidden border-y border-[#27272A]">
        <div className="marquee-track font-serif text-2xl tracking-[0.3em]">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={`track-${k}`} className="flex gap-16 pr-16">
              {["AUTHENTIC", "HANDCRAFTED", "SIGNED & NUMBERED", "MADE IN INDIA", "QR VERIFIED"].map((t) => (
                <span key={t} className="text-[#C5A059]">◆ {t}</span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Featured */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="eyebrow">Curated for You</p>
            <h2 className="font-serif text-3xl md:text-5xl mt-3">Featured Pieces</h2>
          </div>
          <Link to="/shop?featured=true" className="text-xs uppercase tracking-[0.2em] border-b border-[#121212] pb-1">View All</Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-10">
          {featured.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
      </section>

      {/* Categories editorial split */}
      <section className="grid md:grid-cols-2 gap-0">
        {CATS.map((c) => (
          <Link to={`/shop?category=${encodeURIComponent(c.name)}`} key={c.name} className="relative h-[60vh] group overflow-hidden" data-testid={`cat-${c.name}`}>
            <img src={c.img} alt={c.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-[#121212]/30 group-hover:bg-[#121212]/50 transition" />
            <div className="absolute inset-0 flex items-center justify-center text-[#FBF9F5]">
              <div className="text-center">
                <p className="eyebrow text-[#E6C687]">Shop</p>
                <h3 className="font-serif text-3xl md:text-5xl mt-2">{c.name}</h3>
              </div>
            </div>
          </Link>
        ))}
      </section>

      {/* New arrivals */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
        <div className="text-center mb-12">
          <p className="eyebrow">Just Landed</p>
          <h2 className="font-serif text-3xl md:text-5xl mt-3">New Arrivals</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
          {newArr.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
      </section>

      {/* Story split */}
      <section className="bg-[#F5F2EB]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 grid md:grid-cols-2 gap-12 items-center">
          <img src={LOOK1} alt="Craft" className="w-full h-[520px] object-cover" />
          <div>
            <p className="eyebrow">Our Craft</p>
            <h2 className="font-serif text-3xl md:text-5xl mt-3 leading-[1.1]">Every LEE BAG carries the signature of one artisan.</h2>
            <p className="mt-6 text-[#55524D] leading-relaxed">Rooted in India's storied leather heritage, each piece is cut, stitched and finished by a single artisan — signed, numbered and paired with a unique digital certificate. Scan the QR on your bag to meet the maker.</p>
            <Link to="/story" className="btn-lux mt-8 inline-flex">Discover Our Story</Link>
          </div>
        </div>
      </section>

      {/* Bestsellers */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
        <div className="text-center mb-12">
          <p className="eyebrow">Loved by Collectors</p>
          <h2 className="font-serif text-3xl md:text-5xl mt-3">Bestsellers</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
          {best.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
      </section>

      {/* Authenticity */}
      <section className="relative py-24 bg-[#121212] text-[#FBF9F5]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <p className="eyebrow text-[#C5A059]">Verified Authenticity</p>
          <h2 className="font-serif text-3xl md:text-5xl mt-4">Every piece signed. Every piece scannable.</h2>
          <p className="mt-6 text-[#8C867D] max-w-2xl mx-auto">Each LEE BAG unit ships with a unique QR code linking to its digital certificate — the artisan, the piece, and (with your consent) the owner. Copies cannot be authenticated.</p>
          <Link to="/verify/demo" className="btn-lux-gold mt-10 inline-flex" data-testid="home-authenticity-cta">Learn How Verification Works</Link>
        </div>
      </section>

      {/* Testimonials */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24 grid md:grid-cols-3 gap-8">
        {[["Ananya S.", "The Ivory Tote is exquisite — the leather softens beautifully. The QR certificate feels genuinely luxurious."],
          ["Meera R.", "Finally a homegrown Indian house that competes with European heritage brands. Craft is impeccable."],
          ["Kiran D.", "The evening clutch stole the room. Timeless, tactile, and reassuringly authenticated."]].map(([n, t]) => (
          <div key={n} className="border border-[#E2DDD5] p-8 bg-white">
            <p className="text-[#C5A059] mb-4 font-serif text-3xl leading-none">"</p>
            <p className="text-sm leading-relaxed text-[#55524D]">{t}</p>
            <p className="mt-6 text-xs uppercase tracking-[0.2em]">— {n}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
